import React, { useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import FieldText from "../../../../order_managment/common/component/form/FieldText";
import FieldDate from "../../../../order_managment/common/component/form/FieldDate";
import "./FilterModalShipmentReport.css";
import useForm from "../../../../order_managment/common/hooks/useForm";
import { filterKeyCo2 } from "../shipementReportFilterObj";
import moment from "moment";
const style = {
  position: "absolute",
  top: "5rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  width: "50%",
  minWidth: "20rem",
  bgcolor: "background.paper",
  border: "0.1rem solid #017EFA",
  boxShadow: 24,
  borderRadius: "1rem",
  padding: "1rem 0 1rem 2.5rem",
};

const FilterModelShipmentReportCo2 = ({
    setSelectModal,
    selectModal,
    onFillterHandler,
    bodyData,
  }) => {
    
  const OriginUnloco = useForm();
  const destinationUnloco = useForm();
  const destinationPortName = useForm();
  const originPortName = useForm();
  const carrierName = useForm();
  const ETDFromDate = useForm();
  const ETDToDate = useForm();
  const ETAFromDate = useForm();
  const ETAToDate = useForm();
  const shipperName = useForm();
  const onClear = () => {
    OriginUnloco.setValue("");
    destinationUnloco.setValue("");
    destinationPortName.setValue("");
    originPortName.setValue("");
    carrierName.setValue("");
    ETDFromDate.setValue("");
    ETDToDate.setValue("");
    ETAFromDate.setValue("");
    ETAToDate.setValue("");
    shipperName.setValue("");
    onFillterHandler({ ...filterKeyCo2 });
  };
  const onApplyFilters = () => {
    const body = {
      
      OriginUNLOCO: OriginUnloco.value,
      DestinationUNLOCO: destinationUnloco.value,
      OriginPortName: originPortName.value,
      DestinationPortName: destinationPortName.value,
      CarrierName: carrierName.value,
      ShipperName: shipperName.value,
      ShipmentOriginETDFrom: ETDFromDate.value
        ? moment(ETDFromDate.value).format("YYYY-MM-DD")
        : "",
      ShipmentOriginETDTo: ETDToDate.value
        ? moment(ETDToDate.value).format("YYYY-MM-DD")
        : "",
      ShipmentDestinationETAFrom: ETAFromDate.value
        ? moment(ETAFromDate.value).format("YYYY-MM-DD")
        : "",
      ShipmentDestinationETATo: ETAToDate.value
        ? moment(ETAToDate.value).format("YYYY-MM-DD")
        : "",
    };
    onFillterHandler({ ...body });
    setSelectModal({
      filter: false,
      selectCol: false,
    });
  };
  useEffect(() => {
    OriginUnloco.setValue(bodyData?.OriginUNLOCO ?? "");
    destinationUnloco.setValue(bodyData?.DestinationUNLOCO ?? "");
    destinationPortName.setValue(bodyData?.DestinationPortName ?? "");
    originPortName.setValue(bodyData?.OriginPortName ?? "");
    carrierName.setValue(bodyData?.CarrierName ?? "");
    shipperName.setValue(bodyData?.ShipperName ?? "");
    ETDFromDate.setValue(bodyData?.ShipmentOriginETDFrom ?? null);
    ETDToDate.setValue(bodyData?.ShipmentOriginETDTo ?? null);
    ETAFromDate.setValue(bodyData?.ShipmentDestinationETAFrom ?? null);
    ETAToDate.setValue(bodyData?.ShipmentDestinationETATo ?? null);
  }, []);
  return (
    <Modal
      open={selectModal?.filter}
      className={`modalBox`}
      onClose={() =>
        setSelectModal({
          filter: false,
          selectCol: false,
        })
      }
    >
      <Box sx={style}>
        <div className="modalHeader">
          <h5>Filter</h5>
          <div
            className="closeIcon"
            onClick={() =>
              setSelectModal({
                filter: false,
                selectCol: false,
              })
            }
          >
            <CloseIcon
              onClick={() =>
                setSelectModal({
                  filter: false,
                  selectCol: false,
                })
              }
            />
          </div>
        </div>
        <div className="_modalBody container-fluid">
          <div className="row ">
            <div className="col-12">
              <Accordion>
                <AccordionDetails className="mt-3">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="Shipment ETD Date From"
                        
                        value={ETDFromDate.value}
                        onChange={ETDFromDate.onDateChange}
                        error={ETDFromDate.error}
                        errorMsg={ETDFromDate.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate
                     
                        label="Shipment ETD Date To"
                        value={ETDToDate.value}
                        onChange={ETDToDate.onDateChange}
                        error={ETDToDate.error}
                        errorMsg={ETDToDate.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="Shipment ETA Date From"
                        value={ETAFromDate.value}
                        onChange={ETAFromDate.onDateChange}
                        error={ETAFromDate.error}
                        errorMsg={ETAFromDate.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldDate
                        label="Shipment ETA Date To"
                        value={ETAToDate.value}
                        onChange={ETAToDate.onDateChange}
                        error={ETAToDate.error}
                        errorMsg={ETAToDate.errorMsg}
                      />
                    </div>
                    
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Origin UNLOCO"
                        value={OriginUnloco.value}
                        onChange={OriginUnloco.onChange}
                        error={OriginUnloco.error}
                        errorMsg={OriginUnloco.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Destination UNLOCO"
                        value={destinationUnloco.value}
                        onChange={destinationUnloco.onChange}
                        error={destinationUnloco.error}
                        errorMsg={destinationUnloco.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Destination Port Name"
                        value={destinationPortName.value}
                        onChange={destinationPortName.onChange}
                        error={destinationPortName.error}
                        errorMsg={destinationPortName.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Origin Port Name"
                        value={originPortName.value}
                        onChange={originPortName.onChange}
                        error={originPortName.error}
                        errorMsg={originPortName.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Carrier Name"
                        value={carrierName.value}
                        onChange={carrierName.onChange}
                        error={carrierName.error}
                        errorMsg={carrierName.errorMsg}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <FieldText
                        label="Shipper Name"
                        value={shipperName.value}
                        onChange={shipperName.onChange}
                        error={shipperName.error}
                        errorMsg={shipperName.errorMsg}
                      />
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-12">
              <div className="_modalFooter justify-content-between">
                <div className="_outlineButton">
                  <button onClick={onClear}>Clear Filter</button>
                </div>
                <div className="_solidButton">
                  <button onClick={onApplyFilters}>Apply</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
);
};

export default FilterModelShipmentReportCo2;
